module.exports = __webpack_public_path__ + "img/sizzle-plan.1eace29d.svg";